import { useMutation } from '@tanstack/react-query';

import { putUser } from '@/services/api/user';
import { AccountType, getAccountType, unsetAccountType } from '@/utils/account-type';

const QUERY_KEY = ['user', 'put'];

const useUserPutMutation = () => {
  const accountType = getAccountType() ?? AccountType.SPOT;

  return useMutation({
    mutationFn: () => putUser({ accountType }),
    mutationKey: QUERY_KEY,
    onSuccess: () => unsetAccountType(),
    // Provisioning the exchange user is critical; retry transient failures before the
    // caller is allowed to navigate away. createExchangeUser is idempotent server-side.
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 8000),
  });
};

export { QUERY_KEY, useUserPutMutation };
